import request from '@/utils/request';

const baseURL = '/financeapi/finance/setting/'

export const getSystemTime = data =>
  request({
    data,
    url: `${baseURL}getSystemTime`,
    method: 'post'
  });

export const findBizStore = data =>
  request({
    data,
    url: `${baseURL}findBizStore`,
    method: 'post'
  });